/**
 * レアリティの入力欄（Issue #931）。候補はその型番のレアリティ（`GetCardSetCodes` の rarities）、無ければよく使うもの。
 */
export const COMMON_RARITIES = ['N', 'R', 'SR', 'UR', 'UL', 'SE', 'GR', 'HR', 'P', 'M', 'CR', 'PSE', 'GSE', 'QCSE', '20', 'EXSE', 'KC'];

/** 候補（GetCardSetCodes の行）からその型番のレアリティ */
export function raritiesFor(candidates, setCode) {
  const code = String(setCode ?? '').trim().toUpperCase();
  return (candidates ?? []).find((c) => String(c.set_code).toUpperCase() === code)?.rarities ?? [];
}

export default function RarityField({ id, value, options, onChange, onBlur, disabled, testId, width = 90 }) {
  const list = options?.length ? options : COMMON_RARITIES;
  return (
    <>
      <input className="form-input" style={{ width }} placeholder="レアリティ" list={id} data-testid={testId}
        value={value ?? ''} disabled={disabled}
        onChange={(e) => onChange(e.target.value)} onBlur={onBlur}
        onKeyDown={(e) => { if (e.key === 'Enter' && onBlur) e.currentTarget.blur(); }} />
      <datalist id={id}>{list.map((r) => <option key={r} value={r} />)}</datalist>
    </>
  );
}
